<div class="container-detail mb-5">
    <div *ngIf="updates else noUpdate">
        <iframe scrolling="auto" frameborder=0 width="{{ width || 300}}" height="{{height || 200}}" allowfullscreen [src]="updates"></iframe>
    </div>
    <ng-template #noUpdate>
        <div class="noInvestors text-center pb-5">
            <h4 class="text-center fs-24 cl-pink fw-bold">Actualizaciones</h4>
            <p class="m-0 fs-18">
                Estamos trabajando para ofrecerte la mejor experiencia, en breve podras ver las actualizaciones del proyecto.
            </p>
        </div>
    </ng-template>
    

</div>